import gql from 'graphql-tag';

export const DO_CREATE_ORDER = gql`
  mutation CREATE_ORDER($typeOrder: String!) {
    createOrder(typeOrder: $typeOrder) {
      id
    }
  }
`;
